<div class="login-background min-h-screen flex flex-col justify-between items-center overflow-hidden">
  <div class="flex-1 flex items-center justify-center w-full px-4">
    <router-outlet></router-outlet>
  </div>

  <img
    alt="logo"
    class="max-w-[180px] sm:max-w-[220px] h-auto mb-4"
    height="50"
    ngSrc="./assets/images/artesp_logo_white.svg"
    width="244"
  />
</div>
